<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Процедура госпитализации (планирование)</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">Шаг 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Оценка необходимости госпитализации и планирование поступления в стационар</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Получение текстового сообщения, уведомляющего о доступном для госпитализации времени и категориях свободных палат (на день госпитализации)</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Административные процедуры и поступление в палатное отделение</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Оценка необходимости госпитализации и планирование поступления в стационар</h4>
            <p class="depth">
                Если госпитализация признана необходимой для пациента сразу после лечения в отделении или службой экстренной медицинской помощи, ответственный/лечащий врач введет дату госпитализации в систему. <br>
                Затем пациент и его/ее опекун проходят регистрацию в день поступления в стационар и записываются на прием в окне госпитализации/выписки (приемное отделение) в административном отделении.
            </p>

            <h4 class="depth bullet02">Получение текстового сообщения, уведомляющего о процедуре поступления в стационар (в день госпитализации)</h4>
            <p class="depth">
                После выделения палаты в день госпитализации вам поступит сообщение в приложении Kakaotalk или текстовое сообщение, информирующее о времени регистрации и категориях свободных палат. <br>
                Палата будет определена исходя из обстановки, например, наличия свободных палат в день госпитализации, а также выписанных больных. Из этого следует, что категория палаты, которая будет вам выделена в день поступления, может отличаться от требуемой вами категории.
            </p>
            <h4 class="depth bullet02">Процедура поступления в стационар и прохождение регистрации</h4>
            <p class="depth">
                В день поступления, если вы получили уведомление о госпитализации, вам следует прибыть в больницу в указанное время и подписать соглашение стационарного пациента в окне госпитализации/выписки в административном отделении. <br>
                Пациенты, завершившие процедуру регистрации, перейдут в палатное отделение с распределенными палатами, и дежурная медсестра проводит их в нужную.
            </p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="3">Материалы, которые необходимы для поступления в стационар</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="left">
                                средства личной гигиены, в том числе туалетные принадлежности, сменная обувь
                            </td>
                            <td class="left">
                                <p>Медикаменты, назначенные до госпитализации (подготовить)</p>
                                <p class="bullet03">
                                    принесите все назначенные до госпитализации медикаменты, а также рецепты к ним. Если вы берете медикаменты с собой, не принимайте их самостоятельно, пока ответственный/лечащий врач не примет соответствующего решения.
                                </p>
                                <p class="bullet03">
                                    При необходимости лекарственный препарат может быть заменен прописанным в больнице.
                                </p>
                            </td>
                            <td class="left">
                                Для предотвращения инфекций, пожаров и несчастных случаев ограничивается использование увлажнителей воздуха, электрических кофеварок, вентиляторов, электронагревательных устройств (например, электрические одеяла) и воспламеняющихся/горючих материалов.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ Если вам потребуется больничный листок, медицинская карта и/или свидетельство о госпитализации/выписке, вам необходимо будет предъявить паспорт. <br>
                (Примечание: подростки, не достигшие 14 лет, должны предъявить паспорт опекуна и свидетельство о ближайших родственных связях (заверенную копию из семейного реестра и справку о составе семьи)).
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Выписка</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">Шаг 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Оценка состояния для выписки</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Напоминания при выписке</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Проверка страхового случая</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Оплата</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">Шаг 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Получение лекарственных препаратов</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Оценка состояния для выписки</h4>
            <p class="depth ">окончательное решение о выписке будет приниматься ответственным/лечащим врачом в день/за день до выписки.</p>

            <h4 class="depth bullet02 mt20">Напоминания при выписке</h4>
            <p class="depth ">ваша медсестра будет напоминать вам о соблюдении графика, в том числе графика амбулаторного лечения/госпитализации и амбулаторных обследований, и вести медицинскую карту.</p>

            <h4 class="depth bullet02 mt20">страховой скрининг</h4>
            <p class="depth ">После завершения проверки страхового случая и составления медицинской карты оценочная группа проведет оценку страхового покрытия стоимости прописанных лекарственных средств.</p>

            <h4 class="depth bullet02 mt20">Оплата</h4>
            <p class="depth ">как только страховая оценочная группа завершит расчет оплаты, пациенту или опекуну будет отправлено текстовое сообщение. Затем пациент может произвести оплату в окне госпитализации/выписки в административном отделении или в платежном терминале палатного отделения (за поступление/выписку).</p>

            <h4 class="depth bullet02 mt20">Получение лекарственных препаратов</h4>
            <p class="depth ">после совершения оплаты медсестра объяснит некоторые моменты, о которых следует помнить, в том числе схему приема лекарств перед тем, как пациент вернется домой.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Промежуточная оплата за госпитализацию</h3>
            <h4 class="depth bullet02">Оплата за госпитализацию и их проверка производятся в окне «Госпитализация»</h4>
            <p class="depth">
                выписки в административном отделении или в платежном терминале палатного отделения. Указанная сумма является суммой, внесенной в систему до предшествующего дня включительно (и подлежит проверке), из-за этого данная сумма может отличаться от фактической, которую необходимо внести при выписке.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>